<template>
  <div class="login-container">
    <div class="login-card">
      <h2>Crear Cuenta</h2>

      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label for="parent">Nombre del Padre o la Madre</label>
          <input
            id="parent"
            v-model.trim="parent"
            type="text"
            required
            autocomplete="name"
          >

          <label for="kid">Nombre del Niño</label>
          <input
            id="kid"
            v-model.trim="kid"
            type="text"
            required
            autocomplete="off"
          >

          <label for="birthDate">Fecha de Nacimiento del Niño</label>
          <input
            id="birthDate"
            v-model="birthDate"
            type="date"
            required
            autocomplete="bday"
          >

          <label for="email">Email</label>
          <input
            id="email"
            v-model.trim="email"
            type="email"
            required
            autocomplete="email"
          >
        </div>

        <div class="form-group">
          <label for="password">Contraseña</label>
          <input
            id="password"
            v-model="password"
            type="password"
            required
            autocomplete="new-password"
          >
        </div>

        <div
          v-if="error"
          class="error-message"
        >
          {{ error }}
        </div>

        <p>
          Si ya tienes una cuenta, <a href="/login">inicia sesión aquí</a>
        </p>

        <div class="form-group">
          <button
            type="submit"
            class="login-button"
            :disabled="submitting"
          >
            {{ submitting ? "Creando cuenta..." : "Crear Cuenta" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      parent: "",
      kid: "",
      birthDate: "",
      email: "",
      password: "",
      error: "",
      submitting: false,
    };
  },
  methods: {
    async handleSubmit() {
      this.error = "";
      this.submitting = true;

      try {
        await this.$store.dispatch("auth/signup", {
          email: this.email,
          password: this.password,
          parentName: this.parent,
          kidName: this.kid,
          kidBirthDate: this.birthDate,
        });

        this.$emit("signup-success");
      } catch (error) {
        this.error =
          typeof error === "string"
            ? error
            : error?.message || "Ocurrió un error. Por favor, inténtalo de nuevo.";
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  margin: 40px auto;
  max-width: 400px;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.login-card {
  max-width: 400px;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.form-group label {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.form-group input {
  padding: 0.5rem;
  border-radius: 5px;
  font-size: 1rem;
  text-align: center;
  border: 1px solid #cccccc;
}

.login-button {
  background: rgb(101, 1, 173);
  color: white;
  padding: 0.75rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  transition: all 0.3s;
}

.login-button:hover:not(:disabled) {
  background: rgb(0, 0, 207);
}

.login-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.error-message {
  color: red;
  margin-bottom: 1rem;
  text-align: center;
}
</style>